import React from "react";
import Layout from "./layout";
import SpinnerBtn from "../../../../components/SpinnerBtn";

export default function Verify({ handleSubmit, heading, content, handleSkip, sendVerification, setSendVerification , setEnablePage, spinnerBtn}) {
  const handleBackBtn = () =>{
    setEnablePage({
      userInfoPage: false,
      organizationInfoPage: true,
      verifyPage: false
    });
  }
  return (
    <>
      <Layout heading={heading} handleBackBtn={handleBackBtn}>
        <div className="text-center mx-auto my-[4em]">
        {sendVerification ? (<><p className="mb-4">{content}</p>
          <form onSubmit={handleSubmit}>
            <button
              onClick={(e) => {
                handleSubmit(e);
                setSendVerification(false);
              }}
              className="w-auto rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"

            >
              Click Here
            </button>
          </form>
          </>): (<>
            <h2 className="mb-4 text-[green]">{"verification Mail sended successfully to your email"}</h2>
            {/* <a
              href="https://mail.google.com"
              className="hover:border-primary w-50 text-[#fffe] bg-[#5208B4] hover-visible:shadow-none items-center justify-center gap-3.5 rounded-lg border border-stroke bg-gray p-4 hover:bg-opacity-50 dark:border-strokedark dark:bg-meta-4 dark:hover:bg-opacity-50"
            >
              Open Mail
            </a> */}
          </>)}
        </div>
            <div className=" text-center uppercase font-bold">
                or
            </div>
          <div className=" text-center my-[4em]">
          
          {/* <button
        type="button"
        className="w-auto rounded-md bg-[#5208B4] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Submit
      </button> */}
      { !spinnerBtn ? <button
            type="button"
            onClick={handleSkip}
            className=" w-[14%] rounded-md bg-[#5208B4] px-4.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
           {sendVerification ? 'Submit': 'Save & Continue'}
          </button> : <SpinnerBtn style={"w-[14%] rounded-md bg-[#5208B4] px-4.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"}/>}
          </div>
      </Layout>
    </>
  );
}
